import React, { Component } from 'react';
import Question from './Question';
import { Pagination } from 'antd';
import {cloneDeep} from 'lodash';
import PropTypes from 'prop-types'

class Questions extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state = {
      questions_data: props.questions,
			pageSize: 10,
			currentPage: 1,
			questions: this.paginate(props.questions, 10, 1),
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      questions_data: nextProps.questions,
      questions: this.paginate(nextProps.questions, this.state.pageSize, this.state.currentPage),
    })
  }
  
  paginate = (array, page_size, page_number) => {
		--page_number;
		return cloneDeep(array).slice(page_number * page_size, (page_number + 1) * page_size);
  }
  
  onShowSizeChange = (current, pageSize) => {
		this.setState({
			questions: this.paginate(this.state.questions_data, pageSize, current),
			pageSize,
			currentPage: current
		})
  }
  
  scrollToTop(scrollDuration) {
    var scrollStep = -window.scrollY / (scrollDuration / 15),
        scrollInterval = setInterval(function(){
            if ( window.scrollY != 0 ) {
                window.scrollBy( 0, scrollStep );
            }
            else clearInterval(scrollInterval); 
        }, 15);
	}

  render() {
    const {formatMessage} = this.context
    const {categories, quiz_id, subcategories, subjects, deleteQuizQuestion, sources, branches} = this.props;
    const {questions_data, questions, pageSize, currentPage} = this.state;
    return (
      <div className="Questions question-container">
        <div className="block-message">
          {formatMessage('txtMessageQuizzStatics')}: {questions_data.length} questions
        </div>
        <div>
          {questions.map(question => (
            <Question 
              key={'question-' + question.id} 
              question={question} 
              quiz_id={quiz_id} 
              subjects={subjects} 
              categories={categories} 
              sources={sources} 
              branches={branches} 
              subcategories={subcategories} 
              deleteQuizQuestion={deleteQuizQuestion} 
            />))}
        </div>
        <Pagination
          showSizeChanger
          onShowSizeChange={this.onShowSizeChange}
          total={questions_data.length}
          pageSizeOptions={['5', '10', '20', '50']}
          pageSize={pageSize}
          current={currentPage}
          onChange={(page, pageSize) => {
            this.setState({
              questions: this.paginate(this.state.questions_data, pageSize, page),
              pageSize,
              currentPage: page,
            }, () => {
              this.scrollToTop(500);
            })
          }}
        />
      </div>
    );
  }
}

export default Questions;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quiz/components/Questions/index.jsx